








import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import DataTable from '@/components/DataTable/DataTable.vue'
import DataTableBase from '@/classes/DataTable/DataTable'
import DataTableHeader from '@/classes/DataTable/DataTableHeader'
import DataTableHeaderTypes from '@/classes/DataTable/DataTableHeaderTypes'
import DataTableAction from '@/classes/DataTable/DataTableAction'
import { Actions } from '@/store/global/actions'
import { IDialog } from '@/store/global/helpers'
import CreateDialog from '@/components/Recommendations/CreateDialog.vue'
import EditDialog from '@/components/Recommendations/EditDialog.vue'
import AreYouSureDialog from '@/components/Dialogs/AreYouSureDialog.vue'
import http from '@/http'
import can from '@/helpers/can'
import permissions from '@/helpers/permissions'
import RecommendationFieldModel from '@/modules/recommendation/recommendation-field.model'

@Component({
  components: {
    DataTable,
    PageHeader,
  },
  methods: {
    can,
  },
})
export default class SettingsTabsRecommendations extends Vue {
  permissions = permissions
  table = new DataTableBase()
    .setModel(RecommendationFieldModel)
    .setEndpoint('referrals')
    .setIsSortable(false)
    .setHeaders([
      new DataTableHeader().setValue('title').setText('Pavadinimas').setSortable(false),
      new DataTableHeader()
        .setType(DataTableHeaderTypes.boolean)
        .setValue('is_business')
        .setText('Verslui')
        .setSortable(false),
      new DataTableHeader()
        .setType(DataTableHeaderTypes.boolean)
        .setValue('is_individual')
        .setText('Individualiems')
        .setSortable(false),
      new DataTableHeader()
        .setType(DataTableHeaderTypes.boolean)
        .setValue('is_active')
        .setText('Aktyvus')
        .setSortable(false),
    ])
    .setPaginationNotVisible(true)
    .setActions([
      new DataTableAction()
        .setIcon('edit')
        .setTitle('Redaguoti')
        .setAction(this.editItem)
        .setPermissions([permissions.fundingRequests.edit, permissions.fundingRequests.show]),
      new DataTableAction()
        .setIcon('delete')
        .setTitle('Ištrinti')
        .setAction(this.deleteItem)
        .setPermissions([permissions.fundingRequests.delete]),
    ])

  goToCreate(): void {
    this.$store.dispatch(Actions.showDialog, {
      show: true,
      component: CreateDialog,
      maxWidth: 650,
      meta: {
        onSuccess: (entry: RecommendationFieldModel) => this.table.unshiftItem(entry),
      },
    } as IDialog)
  }

  editItem(item: RecommendationFieldModel): void {
    this.$store.dispatch(Actions.showDialog, {
      show: true,
      component: EditDialog,
      maxWidth: 650,
      meta: {
        entry: item,
        onSuccess: (entry: RecommendationFieldModel) => this.table.setItem(entry),
      },
    })
  }

  deleteItem(item: RecommendationFieldModel): void {
    this.$store.dispatch(Actions.showDialog, {
      show: true,
      component: AreYouSureDialog,
      meta: {
        title: 'Ar tikrai norite?',
        text: `Paspausdami taip mygtuką jūs ištrinsite rekomendaciją (${item.title}) ir šis veiksmas negalės būti atšauktas.`,
        onYes: () => this.delete(item),
      },
    })
  }

  delete(item: RecommendationFieldModel): Promise<DataTableBase> {
    return http.delete(`${this.table.endpoint}/${item.uuid}`).then(() => this.table.removeItem(item))
  }
}
